import MyEducationalMaterial from './views/my-education-material.vue';

export default 
  {
    path: '/educational-material',
    name: 'educational-material',
    component: MyEducationalMaterial,
  };
